
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inquiry/[[...step]]",
      function () {
        return require("private-next-pages/inquiry/[[...step]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inquiry/[[...step]]"])
      });
    }
  